module.exports = __webpack_public_path__ + "assets/img/478a-cd.svg";